import { Loader } from 'component/Loader/Loader'
import { Space } from 'component/Space'
import { Gap } from 'component/Space/Gap'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { Banners } from 'page/GeneratingScreen/Banners'
import { Page } from 'page/Page/Page'
import { opt, STAND_BANNER } from 'store/opt'
import { store } from 'store/store'
import { ErrorType, getErrorDescription, getErrorTitle } from 'type/ErrorType'

function renderError() {
  const error: ErrorType = 'generation-failed'

  return (
    <Vertical center>
      <Icon name="error" size={48} error />
      <Gap height={16} />
      <Typo size={13} center error>
        {getErrorTitle(error)}
      </Typo>
      <Gap height={8} />
      <Typo size={13} center pre error>
        {getErrorDescription(error)}
      </Typo>
    </Vertical>
  )
}

function renderProcessing() {
  const { video } = store.generating
  return (
    <Vertical tall>
      <Vertical tall center flex="1">
        <Space center>
          <Loader />
        </Space>
        <Gap height={40} />
        <Typo
          size={opt.tsum ? 15 : 13}
          upper={opt.tsum}
          accent={opt.tsum}
          center
        >
          {video ? i18n('CreatingVideo') : i18n('CreatingOutfit')}
        </Typo>
        <Gap height={8} />
        <Typo size={13} pre secondary center>
          {i18n('CreatingOutfitExplanation')}
        </Typo>
      </Vertical>
      {opt.stand && STAND_BANNER && <Banners />}
    </Vertical>
  )
}

export const GeneratingScreen = observer(() => {
  const { error } = store.generating
  const view = error ? renderError() : renderProcessing()

  return (
    <Page full clear center>
      {view}
    </Page>
  )
})
